export function getBrandLogo(brandIcons, url) {
    const brandNamePattern = brandIcons.map((brand) => brand.brandName.toLowerCase().replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|");

    const regexPattern = new RegExp(`(?:https?:\\/\\/)?(?:www\\.)?(${brandNamePattern})\\.`);
    const match = url.match(regexPattern);

    if (match) {
        const brandName = match[1];

        for (const brand of brandIcons) {
            if (brand.brandName.toLowerCase() === brandName) {
                return brand.brandLogo;
            }
        }
    }

    for (const brand of brandIcons) {
        if (brand.brandName === "DEFAULT_1" || brand.brandName === "DEFAULT_2") {
            return brand.brandLogo;
        }
    }

    return "";
}

export function vibrateDevice(milliseconds) {
    if (navigator.vibrate) {
        navigator.vibrate(milliseconds); // Vibrates device
    } else {
        console.log("Vibration not supported on this device.");
    }
}
